module.exports = __webpack_public_path__ + "assets/4c43d81fc2934c71bd39143bc68ae384.png";